export default {"src":"/_next/static/media/info-circle-blue.1be0dc13.svg","height":16,"width":16};